<template>
  <div class="category-cont">
    <div
      v-for="category in categories"
      ref="linksRef"
      class="category-item"
      :key="category.id"
      :class="{ active: category === value }"
    >
      <div
        @click="
          category === value
            ? $emit('edit', category)
            : onClickCategory(category)
        "
        v-on:dblclick="$emit('edit', category)"
        :style="{
          backgroundImage: `${
            !category.thumbnail
              ? 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),'
              : 'var(--gradient),'
          } url(${category.thumbnail && category.thumbnail.url})`,
        }"
        class="category"
      >
        <p class="title">
          {{ category.title }}
        </p>
        <div class="buttons">
          <p v-if="!category.visible" class="unavailable">
            {{ "عدم نمایش" }}
          </p>
          <vs-button
            @click="$emit('edit', category)"
            class="button"
            style="background-color: #ffffff85 !important"
            color="primary"
            type="filled"
            size="small"
          >
            <img
              style="width: 14px; margin-bottom: -4px"
              src="../assets/icons/edit.svg"
            />
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Category",
    data() {
      return {};
    },
    mounted() {
      this.scrollIntoActiveCategory();
    },
    watch: {
      value(activeCategory) {
        const activeIndex = this.categories.findIndex(
          (element) => element.id === activeCategory.id
        );
        this.scrollIntoActiveCategory(activeIndex);
      },
    },
    methods: {
      onClickCategory(item) {
        window.scrollTo({ top: 0, behavior: "auto" });
        this.$emit("input", item);
      },
      scrollIntoActiveCategory(index = 0) {
        if (this.$refs && this.$refs.linksRef && this.$refs.linksRef[index]) {
          try {
            this.$refs.linksRef[index].scrollIntoView({
              behavior: "auto",
              block: "center",
              inline: "center",
            });
          } catch (e) {
            console.log(e);
          }
        }
      },
    },
    props: {
      categories: {
        type: Array,
        required: true,
      },
      value: {
        type: Object,
      },
    },
  };
</script>

<style scoped lang="scss">
  .category-cont {
    display: flex;
    flex-direction: row;
    overflow: auto hidden;
    padding-bottom: 6px;
    align-items: center;
    gap: 10px;

    ul {
      list-style-type: none;
    }
  }

  .category-item {
    display: flex;
    flex-direction: column;
    transition: 0.3s all linear;

    .category {
      width: 180px;
      height: 80px;
      white-space: nowrap;
      cursor: pointer;
      border-radius: 8px;
      background-color: #1a191983;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 16px;
      position: relative;
      margin: 0 1px;
      transition: 0.3s all linear;
      background-size: cover;
      background-position: center;
      --gradient: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
      overflow: hidden;
      position: relative;

      .title {
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #fff;
        text-align: center;
        font-size: 12px;
        max-width: 180px;
        transition: all 300ms ease-in-out;
      }

      &:hover .title {
        transform: translateX(-10%);
      }
    }

    .buttons {
      position: absolute;
      display: flex;
      opacity: 100;
      padding: 0 5px 5px;
      align-items: flex-end;
      inset: 0;
      justify-content: space-between;
      transition: all 200ms ease-in-out;

      .button {
        width: 24px !important;
        height: 24px !important;
        padding: 4px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        backdrop-filter: blur(10px);
        margin-left: auto;
      }

      .unavailable {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ff9f43;
        padding: 0 5px;
        border-radius: 5px;
        box-shadow: 0 7px 24px 0 #ff9e4369;
        color: white;
        font-size: 0.8rem;
        height: 20px;
      }
    }

    &.active .category {
      background-color: #1a1919e8;
      font-weight: 500;
      --gradient: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
      border: 1px solid rgba(var(--vs-primary), 1);
      height: 90px;
      width: 195px;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 10px;
    }
  }
</style>
W
